<template>
  <div>
    <h1>Support</h1>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="About" name="about"><About /></el-tab-pane>
      <el-tab-pane label="Contact" name="contact"><Contact /></el-tab-pane>
      <el-tab-pane label="Privacy" name="privacy"><Privacy /></el-tab-pane>
      <el-tab-pane label="Slack" name="slack">
        <el-col :sm="24" :md="12">
          <h1>Slack</h1>
          <el-card>
            <p>
              If you you or your teams uses slack you can install the quotur
              slack app using this link.
            </p>
            <a
              href="https://slack.com/oauth/v2/authorize?client_id=28505319715.563178576662&scope=commands,im:history,links:write,team:read,chat:write&user_scope="
            >
              <img
                alt="Add to Slack"
                height="40"
                width="139"
                src="https://platform.slack-edge.com/img/add_to_slack.png"
                srcset="
                  https://platform.slack-edge.com/img/add_to_slack.png    1x,
                  https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
                "
              />
            </a>
          </el-card>
        </el-col>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Privacy from "../views/Privacy";
import About from "../views/About";
import Contact from "../views/Contact";
export default {
  components: { Privacy, About, Contact },
  data() {
    return {
      activeName: "about"
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>
